// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IGJk","inner":"styles_inner__2O55k","right":"styles_right__D5PfC","close":"styles_close__1f8Yu","footer":"styles_footer__1RMsv"};